import gql from 'graphql-tag'

export const setCalendarInsertMode = gql`
	mutation setCalendarInsertMode($mode: String!) {
		setCalendarInsertMode(mode: $mode) @client
	}
`

export const setCalendarDate = gql`
	mutation setCalendarDate($date: String!) {
		setCalendarDate(date: $date) @client
	}
`

export const setZoomLevel = gql`
	mutation setZoomLevel($calendarZoomLevel: String!) {
		setZoomLevel(calendarZoomLevel: $calendarZoomLevel) @client
	}
`

export const setActiveLocationMutation = gql`
	mutation setLocation($location: String!) {
		setLocation(location: $location) @client
	}
`

export const setCalendarResource = gql`
	mutation setCalendarResource($resource: String!) {
		setCalendarResource(resource: $resource) @client
	}
`

export const calendarViewMutation = gql`
	mutation setCalendarView($view: String!) {
		setCalendarView(view: $view) @client
	}
`
